import * as React from "react"
import projectMapStyles from "./projectMapStyles.json"
import { GoogleMap } from "@react-google-maps/api"

interface ProjectMapProps {
  markers: JSX.Element
  defaultZoom?: number
  defaultCenter?: { lat: number; lng: number }
  defaultBounds?: { lat: number; lng: number }
  key?: number
}

type Libraries = ("drawing" | "geometry" | "localContext" | "places" | "visualization")[]
export const libraries = ["geometry", "drawing", "places"] as Libraries

export function ProjectMapRoot(props: ProjectMapProps) {
  const { markers } = props
  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    if (props.defaultBounds) {
      const bounds = new window.google.maps.LatLngBounds(props.defaultBounds)
      map.fitBounds(bounds)
    } else {
      map.setCenter(props.defaultCenter || { lat: 35, lng: -80 })
      map.setZoom(10)
    }

    setMap(map)
  }, [])

  return (
    <GoogleMap
      mapContainerStyle={{ height: "100%" }}
      onLoad={onLoad}
      options={{ styles: projectMapStyles }}
      key={props.key}
    >
      {markers}
    </GoogleMap>
  )
}
